<div class="map-tooltip-container">
  <div *ngIf="!!properties || !!baseProperties">
    <div *ngIf="!!layerItem" class="map-tooltip-header">
      <h3 class="map-tooltip-title">{{ elementName }}</h3>
    </div>

    <div *ngIf="!!properties && !!labelPropertiesMap" class="properties-container">
      @for (propertyKey of propertyKeys; track propertyKey) {
      <div class="property-label">{{ labelPropertiesMap[propertyKey] }}</div>
      <div class="property-value">{{ properties[propertyKey] }}</div>
      }
    </div>
  </div>
</div>
